/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_By_ListeningInputs */

const en_onboarding_results_by_listening = /** @type {(inputs: Onboarding_Results_By_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by Listening instead of reading`)
};

const es_onboarding_results_by_listening = /** @type {(inputs: Onboarding_Results_By_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`escuchando en vez de leer`)
};

/**
* | output |
* | --- |
* | "by Listening instead of reading" |
*
* @param {Onboarding_Results_By_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_by_listening = /** @type {((inputs?: Onboarding_Results_By_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_By_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_by_listening(inputs)
	return en_onboarding_results_by_listening(inputs)
});